var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-text-field',{attrs:{"label":_vm.label,"prepend-icon":"mdi-calendar","type":"date"},model:{value:(_vm.valor),callback:function ($$v) {_vm.valor=$$v},expression:"valor"}})
}
var staticRenderFns = []

export { render, staticRenderFns }